import React from 'react'
import { useSelector } from 'hooks/use-redux'
import {
  getBusinessId,
  getRightsHoldersOpportunitiesForm,
} from '@disco/state-management/selectors/business'
import { getUserId } from '@disco/state-management/selectors/user'
import Alert from 'components/ui/alert'
export const RightsHoldersOpportunities = (): React.ReactNode => {
  const userId = useSelector(getUserId)
  const businessId = useSelector(getBusinessId)
  const formUrl = useSelector(getRightsHoldersOpportunitiesForm)
  if (!formUrl) return null
  const typeformUrl = `${formUrl}#user_id=${userId}&business_id=${businessId}`
  return (
    <Alert
      title="DISCO Ecosystem Opportunities [beta]"
      status="info"
      id="rights-holders-opportunities"
      dismissible
      icon="info"
    >
      DISCO is interested in helping curate opportunities for the awesome rights
      holders and artists in our ecosystem.
      <br />
      Please take this quick survey to let us know what opportunities you&#39;re
      interested in being a part of!
      <br />
      <br />
      <a
        className="text-link"
        href={typeformUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        Take Survey
      </a>
    </Alert>
  )
}
